document.addEventListener('DOMContentLoaded', () => {

  // Get all the review elements
  const reviews = document.querySelectorAll('.review');

  if (reviews.length) {

    // Set the initial index and interval
    let currentIndex = 0;
    let intervalId = setInterval(showNextReview, 5000);

    // Add event listeners to the arrow buttons
    const status = document.querySelector('.reviews__status');
    const prevButton = document.querySelector('.reviews__btn--prev');
    const nextButton = document.querySelector('.reviews__btn--next');
    if (prevButton) prevButton.addEventListener('click', showPrevReview);
    if (nextButton) nextButton.addEventListener('click', showNextReview);

    // Function to show the previous review
    function showPrevReview() {
      clearInterval(intervalId);
      currentIndex = (currentIndex - 1 + reviews.length) % reviews.length;
      showReview(currentIndex);
      intervalId = setInterval(showNextReview, 5000);
    }

    // Function to show the next review
    function showNextReview() {
      clearInterval(intervalId);
      currentIndex = (currentIndex + 1) % reviews.length;
      showReview(currentIndex);
      intervalId = setInterval(showNextReview, 5000);
    }

    // Function to show a specific review
    function showReview(index) {
      status.textContent = `${index + 1} / ${reviews.length}`;
      reviews.forEach((review, i) => {
        if (i === index) {
          review.hidden = false;
          review.setAttribute('aria-hidden', false);
        } else {
          review.hidden = true;
          review.setAttribute('aria-hidden', true);
        }
      });
    }

    // Show the initial review
    showReview(currentIndex);

  }

});
